export const headerMenus = [
  {
    active: true,
    name: 'Loto 7/28',
    url: '/'
  },
  {
    active: false,
    name: 'How to play',
    url: '/how-to-play'
  },
  {
    active: false,
    name: 'Results',
    url: '/results'
  },
  {
    active: false,
    name: 'FAQ\'S',
    url: '/faqs'
  }
];
